import { Component, Input, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import {
  addFileIcon,
  arrowCloseIcon,
  arrowOpenIcon,
  boxesIcon,
  boxIcon,
  calendarIcon,
  chartIcon,
  checkIcon,
  clockIcon,
  cogIcon,
  dimensionsIcon,
  menuIcon,
  minusIcon,
  chevronDownIcon,
  errorIcon,
  eyeIcon,
  filterIcon,
  flagIcon,
  globalIcon,
  groupIcon,
  infoIcon,
  lockedIcon,
  logoutIcon,
  mailIcon,
  mapIcon,
  moneyIcon,
  penIcon,
  phoneIcon,
  pinIcon,
  plusIcon,
  profileIcon,
  representativeIcon,
  shieldIcon,
  sortIcon,
  statusIcon,
  technicianIcon,
  ticketIcon,
  unlockedIcon,
  chevronUpIcon,
  userIcon,
  warningIcon,
  xIcon,
  chevronRightIcon,
  chevronLeftIcon,
  messageIcon,
  houseIcon,
  detailsIcon,
  qrIcon,
  linkIcon,
  copyIcon,
  documentIcon,
  arrowRightIcon,
  reverseIcon,
  saveIcon,
  dashboardIcon,
  flameIcon,
  snowflakeIcon,
  questionmarkIcon,
  deltaIcon,
  upTrendIcon,
  downTrendIcon,
  exportIcon,
  starOutlinedIcon,
  starFilledIcon,
  homeIcon,
  targetIcon,
  serverIcon,
  sourceIcon,
  closeIcon,
} from './icons'
import { NgClass, NgStyle } from '@angular/common'

@Component({
  selector: 'icon-component',
  templateUrl: './icon.component.html',
  standalone: true,
  imports: [NgClass, NgStyle],
})
export class IconComponent implements OnInit {
  @Input() size: IconSize = IconSize.DEFAULT
  @Input() icon: string = ''
  @Input() color: string = '#9DA6A6'

  IconSize = IconSize
  iconSvg: SafeHtml = ''

  private iconsMap: { [key: string]: string } = {
    clock: clockIcon,
    phone: phoneIcon,
    check: checkIcon,
    mail: mailIcon,
    locked: lockedIcon,
    unlocked: unlockedIcon,
    chart: chartIcon,
    user: userIcon,
    box: boxIcon,
    boxes: boxesIcon,
    cog: cogIcon,
    flag: flagIcon,
    profile: profileIcon,
    plus: plusIcon,
    ticket: ticketIcon,
    info: infoIcon,
    group: groupIcon,
    pin: pinIcon,
    map: mapIcon,
    eye: eyeIcon,
    logout: logoutIcon,
    dimensions: dimensionsIcon,
    chevronUp: chevronUpIcon,
    chevronDown: chevronDownIcon,
    chevronRight: chevronRightIcon,
    chevronLeft: chevronLeftIcon,
    shield: shieldIcon,
    x: xIcon,
    representative: representativeIcon,
    technician: technicianIcon,
    global: globalIcon,
    error: errorIcon,
    warning: warningIcon,
    addFile: addFileIcon,
    filter: filterIcon,
    calendar: calendarIcon,
    money: moneyIcon,
    status: statusIcon,
    sort: sortIcon,
    pen: penIcon,
    arrowOpen: arrowOpenIcon,
    arrowClose: arrowCloseIcon,
    menu: menuIcon,
    minus: minusIcon,
    message: messageIcon,
    house: houseIcon,
    details: detailsIcon,
    qr: qrIcon,
    link: linkIcon,
    copy: copyIcon,
    document: documentIcon,
    arrowRight: arrowRightIcon,
    reverse: reverseIcon,
    save: saveIcon,
    dashboard: dashboardIcon,
    flame: flameIcon,
    snowflake: snowflakeIcon,
    questionmark: questionmarkIcon,
    delta: deltaIcon,
    uptrend: upTrendIcon,
    downtrend: downTrendIcon,
    export: exportIcon,
    starFilled: starFilledIcon,
    starOutlined: starOutlinedIcon,
    target: targetIcon,
    home: homeIcon,
    server: serverIcon,
    source: sourceIcon,
    close: closeIcon,
  }

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const rawSvg = this.iconsMap[this.icon] || ''
    this.iconSvg = this.sanitizer.bypassSecurityTrustHtml(rawSvg)
  }
}

export enum IconSize {
  LARGE = 'large',
  DEFAULT = 'default',
  SMALL = 'small',
  MINI = 'mini',
  XSMALL = 'xsmall',
}
